"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function VideoCamera24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
        react_1.default.createElement("desc", null, "Created with Sketch."),
        react_1.default.createElement("g", { id: "video-camera-24", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("path", { d: "M15,5 C16.1045695,5 17,5.8954305 17,7 L17,8.75 L21.7760008,5.76499947 C22.1506701,5.5308312 22.6442304,5.64472974 22.8783986,6.01939896 C22.9578644,6.14654424 23,6.29346234 23,6.44339811 L23,17.5566019 C23,17.9984297 22.6418278,18.3566019 22.2,18.3566019 C22.0500642,18.3566019 21.9031461,18.3144663 21.7760008,18.2350005 L17,15.25 L17,17 C17,18.1045695 16.1045695,19 15,19 L4,19 C2.8954305,19 2,18.1045695 2,17 L2,7 C2,5.8954305 2.8954305,5 4,5 L15,5 Z M15,7 L4,7 L4,17 L15,17 L15,7 Z M21,8.607 L17,11.107 L17,12.892 L21,15.392 L21,8.607 Z", id: "Combined-Shape", fill: "#000000", fillRule: "nonzero" })));
}
function VideoCamera24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(VideoCamera24Svg, Object.assign({}, svgProps)));
}
exports.default = VideoCamera24;
//# sourceMappingURL=VideoCamera24.js.map